import React from "react";
import {
  ClientWiseUserTimeSheetType,
  EmployeeTimesheetType,
} from "../../../redux/timeSheet/timeSheetType";
import TimeSheetClientWiseUserTableData from "./TimeSheetClientWiseUserTableData";
import GstTableHeader from "../../Gst/common/GstTableHeader";
import { CLIENT_WISE_USER_TOTAL_HOURS_HEADERS } from "../../../constant/timeSheetReportDropDown/timeSheetListConst";

type AppProps = {
  timeSheetClientWiseUserReport: ClientWiseUserTimeSheetType;
  data: EmployeeTimesheetType[] | [];
  setData:React.Dispatch<React.SetStateAction<[] | EmployeeTimesheetType[]>>;
};



const TimeSheetClientWiseUserTable = ({
  timeSheetClientWiseUserReport,
  data,
  setData
}: AppProps) => {
  return (
    <div>
      <div className="gstr" style={{minHeight:"400px"}}>
        <table className="table">
          <thead className="thead-light">
            <tr>
              <th></th>
              <th colSpan={2} >TOTAL HOURS</th>
              <th >{timeSheetClientWiseUserReport?.billable_sum?.toFixed(2)}</th>
            </tr>
          </thead>
          <tbody>
            <TimeSheetClientWiseUserTableData
              data={data}
              setData={setData}
              tableHeader={CLIENT_WISE_USER_TOTAL_HOURS_HEADERS}
            />
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TimeSheetClientWiseUserTable;
